import { render, staticRenderFns } from "./RecordCheck.vue?vue&type=template&id=49595d85&scoped=true"
import script from "./RecordCheck.vue?vue&type=script&lang=js"
export * from "./RecordCheck.vue?vue&type=script&lang=js"
import style0 from "./RecordCheck.vue?vue&type=style&index=0&id=49595d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49595d85",
  null
  
)

export default component.exports